import { render, staticRenderFns } from "./DetailResep.vue?vue&type=template&id=221b2ebe&"
import script from "./DetailResep.vue?vue&type=script&lang=js&"
export * from "./DetailResep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports